import { WebMercatorViewport } from "@math.gl/web-mercator";
import bbox from "@turf/bbox";

/**
 * Gets the center and zoom level of a map with the given bounds and viewport
 * @param bounds two opposite bounding corners, in [lon, lat] form
 * @param width the viewport width
 * @param height the viewport height
 * @returns The lat-long center of the map, along with a zoom level that will fit the bounds
 */
export const getViewportFromBounds = (
  bounds: {
    maxCorner: [number, number];
    minCorner: [number, number];
  },
  width: number,
  height: number,
) => {
  const vp = new WebMercatorViewport({ width, height });

  const {
    longitude: lon,
    latitude: lat,
    zoom,
  } = vp.fitBounds([bounds.maxCorner, bounds.minCorner], {
    padding: 40,
  });
  return {
    lon,
    lat,
    zoom,
  };
};

export function getCoordinateBounds(features: any[]) {
  return features.reduce(
    ({ minLat, maxLat, minLon, maxLon }: any, { geometry }: any) => {
      const [minX, minY, maxX, maxY] = bbox({ type: "Point", ...geometry });
      return {
        minLat: Math.min(minLat, minY),
        maxLat: Math.max(maxLat, maxY),
        minLon: Math.min(minLon, minX),
        maxLon: Math.max(maxLon, maxX),
      };
    },
    {
      minLat: Infinity,
      maxLat: -Infinity,
      minLon: Infinity,
      maxLon: -Infinity,
    },
  );
}
